export default __webpack_public_path__ + "static/media/fusion-model.3803b8da.png";